function BlockSliderImages() {
	this.build();
}

BlockSliderImages.prototype.build = function(){
	this.sliders = $('.block--slider-images');
	this.sliders.each(function(index, elem) {
		const slider = $(elem).find('.slider-images');
		const sliderDots = $(elem).find('.slider-dots');
		const prevBtn = $(elem).find('.slider__prev');
		const nextBtn = $(elem).find('.slider__next');
		let multiple = false;
		let variableWidth = false;
		let centerMode = false;

		if (slider.data('multiple') == 1) {
			multiple = true;

			if (slider.data('crop') == 0) {
				variableWidth = true;
				// centerMode = true;
			}
		}

		if (multiple) {
			slider.slick({
				autoplay: true,
				autoplaySpeed: 4000,
				arrows: false,
				draggable: true,
				dots: false,
				fade: false,
				speed: 750,
				infinite: true,
				pauseOnHover: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: variableWidth,
				centerMode: centerMode,
				mobileFirst: true,
				responsive: [
					{
						breakpoint: 500,
						settings: {
							slidesToShow: 2
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 3
						}
					}
				]
			});
		} else {
			slider.slick({
				autoplay: true,
				autoplaySpeed: 4000,
				arrows: false,
				draggable: true,
				dots: false,
				fade: false,
				speed: 750,
				infinite: true,
				pauseOnHover: false,
				slidesToShow: 1,
				slidesToScroll: 1
			});
		}

		slider.magnificPopup({
			// delegate: '.slick-slide:not(.slick-cloned) a',
			delegate: '.slick-slide a',
			type: 'image',
			tLoading: 'Loading image #%curr%...',
			mainClass: 'mfp-img-mobile',
			gallery: {
				// enabled: true,
				enabled: false,
				navigateByImgClick: true,
				preload: [0,1] // Will preload 0 - before current, and 1 after the current image
			},
			image: {
				tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
				titleSrc: function(item) {
					return item.el.attr('title');
				}
			}
		});

		slider.on('afterChange', function (event, slick, currentSlide) {
			sliderDots.find('li').removeClass('current');
			sliderDots.find('li.item-'+currentSlide).addClass('current');
		});

		sliderDots.find('li').on('click', function() {
			slider.slick('slickGoTo', $(this).data('slide'));
		});

		prevBtn.click(function (e) {
			slider.slick('slickPrev');
		});

		nextBtn.click(function (e) {
			slider.slick('slickNext');
		});
	});
};
